import React from 'react';

import PortalItinerary from 'components/shared/LandingPage/blocks/PageHeader/PortalItinerary';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { withLandingPageLayoutContext } from 'components/shared/LandingPage/contexts/LandingPageLayoutContext';
import StartArrow from 'components/shared/LandingPage/RightSide/StartArrow';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useCustomStyles, useCustomFonts } from 'hooks/useCustomFront';

import Builder from '../../ItinerariesItemLanding/Builder';
import { getPageInfo } from '../functions';

const renderPageHeader = ({ links, pageIndex }) => {
  if (pageIndex !== 0) return null;

  return <PortalItinerary renderMenu={() => null} links={links} disabled />;
};

function SamplePreview(props) {
  const { landingData, page, anchor, links, pageIndex, landingTheme } = props;

  const targetPage = getPageInfo(page);

  useCustomStyles({ css: targetPage?.customStyles, customId: targetPage.id });
  useCustomFonts({ landingItem: targetPage, customId: targetPage.id });

  return (
    <Builder
      renderPageHeader={renderPageHeader}
      renderStartArrow={({ screens, startArrow }) => {
        if (screens?.length <= 1 || !startArrow) return;

        return <StartArrow to={screens[1]} containerId={LANDING_PAGES_CONTAINER_ID} />;
      }}
      landingData={landingData}
      anchor={anchor}
      screens={links}
      pageIndex={pageIndex}
      page={page}
      itinerariesItemType={ITINERARIES_ITEM_TYPES.ITINERARY}
      isSamplePreview
      readOnly
      landingTheme={landingTheme}
    />
  );
}

export default withLandingPageLayoutContext(SamplePreview);
